// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Guyana from '../_raw/flag/icon_flag_guyana.png';

export default () => <img src={Guyana} alt="Guyana" />;
